import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import DCENJ from '../../Images/LSE.jpg';
import '../../css/Global.min.css';
import Competencias from '../../Images/Competencias.jpg';
import Modelo2 from '../../Images/Modelo2.jpg';
import Modalidades from '../../Images/Modalidad11.jpg';
import Biblioteca from '../../Images/Biblioteca.jpg';
import Titulacion from '../../Images/Titulacion.jpg';
import Informes from '../Informes';
import DIngreso from '../../Images/DIngreso.jpg';



class DEAA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Materias: [],
            Semestres: [],
            Costos: [],
            Inscripcion: "",
            Colegiatura: "",
            Prope: "",
            Actual: '',
            Clave: "LSZN",
            FechaInicio: "",
            FechaLimite: ""

        }


        var xhr = new XMLHttpRequest();
        var principal = this;
        var sobre = { Carrera: this.state.Clave };

        xhr.open("POST", "api/Web/GetPrograma", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                var materias = JSON.parse(xhr.responseText).Table;
                var costos = JSON.parse(xhr.responseText).Table1;
                var fechaInicio = JSON.parse(xhr.responseText).Table2[0].FechaI;
                var fechaLimite = JSON.parse(xhr.responseText).Table2[0].FechaL;
                var prope = costos.find((item) => {
                    if (item.Prope === 1) {
                        return item.Formato
                    }
                });
                var insc = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 0) {
                        return item.Formato
                    }
                });

                var col = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 1) {
                        return item.Formato
                    }
                });

                var semestres = [];
                for (let i = 0; i < materias.length; i++) {
                    var buscar = semestres.find((item) => {
                        if (item == materias[i].semestre) {
                            return item;
                        }
                    });

                    if (buscar == null || buscar == undefined) {
                        semestres.push(materias[i].semestre);
                    };
                }
                if (prope === undefined) {
                    prope = { Formato: "" };
                };
                if (insc === undefined) {
                    insc = { Formato: "" };
                };
                if (col === undefined) {
                    col = { Formato: "" };
                };
                if (fechaInicio === undefined) {
                    fechaInicio = "";
                };
                if (fechaLimite === undefined) {
                    fechaLimite = "";
                };
                principal.setState({
                    Materias: materias,
                    Semestres: semestres,
                    Costos: costos,
                    Prope: prope.Formato,
                    Inscripcion: insc.Formato,
                    Colegiatura: col.Formato,
                    FechaInicio: fechaInicio,
                    FechaLimite: fechaLimite
                });

                //principal.iniciarWs(usuario + '|' + xhr.responseText + '|', usuario);
            } else {
                //******** Mensaje a Usuario correcto

                //alert(xhr.status);
                //alert(xhr.responseText);

            }


        };

        if (this.state.Materias.length === 0) {
            xhr.send(JSON.stringify(sobre));
        }
        //xhr.send(JSON.stringify(valores));

        this.materiasSemestre = this.materiasSemestre.bind(this);
        this.semestreTexto = this.semestreTexto.bind(this);
    }

    materiasSemestre(semestre) {
        var materias = [];
        for (let i = 0; i < this.state.Materias.length; i++) {
            if (this.state.Materias[i].semestre == semestre) {
                materias.push(this.state.Materias[i]);
            }
        }

        return materias;
    }

    semestreTexto(semestre) {
        var valor = "";
        switch (semestre) {

            case 1:
                valor = "Primer";
                break;
            case 2:
                valor = "Segundo";
                break;
            case 3:
                valor = "Tercer";
                break;
            case 4:
                valor = "Cuarto";
                break;
            case 5:
                valor = "Quinto";
                break;
            case 6:
                valor = "Sexto";
                break;
            case 7:
                valor = "Séptimo";
                break;
            case 8:
                valor = "Octavo";
                break;
            case 9:
                valor = "Noveno";
                break;
            case 10:
                valor = "D&eacute;cimo";
                break;
            case 11:
                valor = "D&eacute;cimo Primer";
                break;
            case 12:
                valor = "D&eacute;cimo Segundo";
                break;

        }
        return valor;
    }

    componentDidUpdate() {
        if (this.state.Actual != window.location.href) {
            this.state.Actual = window.location.href;
            this.props.reportarVisita(window.location.href, this.state.Clave, false)
        };
    }

    render() {
        return (
            <div>
                <div className="wrapper">
                    <MetaTags>
                        <title>Licenciatura en Sociología de la Educación</title>
                        <meta name="description" content="Licenciatura en Sociología de la Educación en modalidad 100% en l&iacute;nea y presencial en las ciudades de Irapuato, Loreto y Zacatecas" />
                        <meta name="keywords" content="Licenciatura, Pedagogia, Educacion, sociología, presencial, irapuato, loreto, zacatecas, becas en linea" />
                        <meta property="og:title" content="Licenciatura en Sociología de la Educación" />
                        <meta property="og:description" content="Licenciatura en Sociología de la Educación en modalidad 100% en l&iacute;nea y presencial en las ciudades de Irapuato, Loreto y Zacatecas" />
                    </MetaTags>
                </div>
                <div className="content">
                    <div className="ImgenCentral2">
                        <img src={DCENJ} alt="Doctorado en Pedagogía" />
                    </div>
                    <div className="FondoAlterno" style={{ maxWidth: "100%" }}>
                        <div className="Centrado" style={{ maxWidth: "45%", margin: "auto", padding: "50px" }}>
                            <p className="Parrafo1 Centrado" style={{ fontSize: "18pt" }} >
                                La <strong>Licenciatura en Sociolog&iacute;a de la Educaci&oacute;n</strong> esta diseñada para los que buscan estudiar los procesos educativos con &eacute;nfasis en la dimensi&oacute;n social
                                            </p>
                        </div>
                    </div>
                    <div >
                        <div className="Separador ListaTabla DosColumnas" style={{ backgroundColor: "transparent" }}>
                            <br />
                            <ul>
                                <li>
                                    <div style={{ textAlign: "right" }}>
                                        <img src={Modalidades} alt='Modalidades' style={{ width: "90%" }} />
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <br />
                                        <h2 className="Negrita"><strong>Modalidad 100% en l&iacute;nea</strong></h2>
                                        <p className="Parrafo1 Justificado">
                                            <strong>Campus virtual.</strong> Plataforma disponible 24/7 los 365 días del año. Acuerdo 06432LSE090122 con fecha 22 de Enero del 2009 con número de Expediente SEP 32-00049
                                        </p>
                                        <h2 className="Negrita"><strong>Modalidad presencial</strong></h2>
                                        <p className="Parrafo1 Centrado">Clases  sabatinas. Se oferta en las siguientes ciudades:</p>
                                        <p className="Parrafo1 Justificado">
                                            <strong>Plantel Irapuato.</strong> Acuerdo SEG 098-98 con fecha 8 de Mayo del 1998 con número de Expediente SEP 11-00157
                                        </p>
                                        <p className="Parrafo1 Justificado">
                                            <strong>Plantel Zacatecas.</strong> Acuerdo 08932LSE040623 con fecha 23 de Junio del 2004 con número de Expediente SEP 32-00049
                                        </p>
                                        <p className="Parrafo1 Justificado">
                                            <strong>Plantel Loreto.</strong> Acuerdo 02532LSE080312 con fecha 12 de Marzo del 2008 con número de Expediente SEP 32-00073
                                        </p>
                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>

                    <div className="CentrarH ListaTabla MarginAA">
                        <ul style={{ marginLeft: "65px" }}>

                            <li>
                                <div className="MiniHistoria">
                                    <img src={Biblioteca} />
                                    <div>
                                        <h3>Biblioteca Digital</h3>
                                        <p>Todos tus recursos siempre disponibles, acceso a m&aacute;s de 300,000 libros e investigaciones completas</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={Modelo2} />
                                    <div>
                                        <h3>Modelo Educativo</h3>
                                        <p>El seguimiento a nuestros alumnos es importante, clases sabatinas en tiempo real, para solidificar tus aprendizajes y resolver dudas</p>
                                        <p>aplica sólo en modalidad en l&iacute;nea</p>
                                        <a href=''>Ver video explicativo</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={Titulacion} />
                                    <div>
                                        <h3>Formas de Titulaci&oacute;n</h3>
                                        <p>Más de seis opciones de titulaci&oacute;n disponibles</p>
                                        <a href=''>M&aacute;s informaci&oacute;n</a>
                                    </div>
                                </div>
                            </li>


                        </ul>
                    </div>
                    {(this.state.Materias.length === 0) ?
                        <div>NO</div>
                        :
                        <div className="CentrarH ListaTabla MarginAA FondoAlterno">

                            <br />
                            <h2 className="Negrita"><strong>Plan de estudios</strong></h2>

                            <div className="RequisitosCurriculares" style={{ paddingTop: "20px", textAlign: "left" }}>
                                <table>
                                    <tr>
                                        <td style={{ width: "150px" }}>
                                            <p><strong>Duraci&oacute;n: </strong></p>
                                        </td>
                                        <p>4 años (8 semestres)</p>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "150px" }}>
                                            <p><strong>Requiere proped&eacute;utico: </strong></p>
                                        </td>
                                        <p>S&iacute;, el curso proped&eacute;utico tiene una duraci&oacute;n de 8 semanas</p>
                                        <td></td>
                                    </tr>
                                   
                                </table>


                            </div>
                            <div>
                                <ul style={{ marginLeft: "65px" }}>
                                    {this.state.Semestres.map((itemS, indexS) => {
                                        return (
                                            <li style={{ width: "380px", minWidth: "380px" }}>
                                                <div className="MiniHistoria2 Justificar" style={{ border: "solid 1px gray" }}>
                                                    <table>
                                                        <tr>
                                                            <td style={{ fontSize: "14pt" }}>
                                                                <strong> {this.semestreTexto(itemS)} Semestre</strong>
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td> &nbsp;
                                                        </td>

                                                        </tr>
                                                        {this.materiasSemestre(itemS).map((materia, index2) => {
                                                            return (
                                                                <tr>
                                                                    <td >

                                                                        <div className="Fuente2" style={{ textAlign: "left", fontWeight: "normal", marginBottom: "5px" }}>
                                                                            - {materia.materia_nombre}
                                                                        </div>
                                                                    </td>
                                                                </tr>


                                                            );
                                                        }
                                                        )}
                                                    </table>


                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>

                            </div>

                        </div>
                    }

                    <div className="Separador ListaTabla2 DosColumnas2 FondoBase" style={{ backgroundColor: "transparent" }}>
                        <ul style={{ width: "80%", margin: "auto" }}>

                            <li>
                                <div style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                    <h2><strong>Documentos de ingreso</strong></h2>
                                    <br />
                                    <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                        <tr>
                                            <td>
                                                - Acta de Nacimiento
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - CURP
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - Certificado de secundaria
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - Certificado de bachillerato
                                                </td>
                                        </tr>
                                    </table>
                                    <br />
                                    <div style={{ textAlign: "left", right: "10%", fontSize: "12pt" }}>
                                        <p>
                                            Para la modalidad en l&iacute;nea se entregan documentos escaneados.
                                            </p>
                                        <p>
                                            Los alumnos internacionales, deber&aacute;n entregar copias a color de los documentos originales, apostillados en la embajada de M&eacute;xico de su pa&iacute;s.
                                            </p>
                                    </div>
                                </div>
                            </li>
                            {this.state.Costos.length > 0 ?

                                <li>
                                    <div className="Centado" style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                        <h2><strong>Costos - Modalidad en l&iacute;nea</strong></h2>
                                        <br />
                                        <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                            <tr>
                                                <td>
                                                    Curso Proped&eacute;utico
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Prope}</div>
                                                </td>
                                                <td>
                                                    &Uacute;nico pago
                                                </td>
                                            </tr>
                                            <tr style={{ height: "120px" }}>
                                                <td>
                                                    Inscripci&oacute;n
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Inscripcion}</div>
                                                </td>
                                                <td>
                                                    Pago al inicio de cada semestre
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Colegiatura mensual
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Colegiatura}</div>
                                                </td>
                                                <td>
                                                    6 cuotas por semestre, vence el d&iacute;a 17 de cada mes.
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                </li>
                                :
                                null
                            }

                        </ul>


                    </div>
                    <Informes solicitarCarrera={() => { return this.state.Clave; }}
                        reportarVisita={this.props.reportarVisita}
                        getGuid={this.props.getGuid}
                        fechaInicio={() => { return this.state.FechaInicio }}
                        fechaLimite={() => { return this.state.FechaLimite }}
                    />
                </div>
            </div>
        );
    }
}

export default DEAA;


// WEBPACK FOOTER //
// ./src/components/Licenciaturas/LSE.js